import ProductCard from "components/Product/ProductCard"
import ProductList from "components/Product/ProductList"
import Typeahead from "components/Typeahead/Typeahead"
import { action, computed, observable } from "mobx"
import { observer } from "mobx-react"
import queryString from "qs"
import React from "react"
import { Link, withRouter } from "react-router-dom"
import { Button, Form, Header, Icon, Image, Segment, Grid, Menu, Modal, Card } from "semantic-ui-react"
import shop from "shop/shop"
import cmsStore from "stores/cmsStore"
import productStore from "stores/productStore"

const BASE = shop.config.BASE

let tagIndex = 0

export class Tag {
  @observable id
  @observable left = "10%"
  @observable top = "10%"

  constructor( { productId, left, top } ) {
    this.id = `TAG_${tagIndex++}`
    this.productId = productId
    this.left = left
    this.top = top
  }

  @action
  place( { x, y } ) {
    this.x = x
    this.y = y
    this.left = `${x}%`
    this.top = `${y}%`
  }
}

export class EImage {
  @observable tagById = new Map()
  @observable src
  @observable loading = false
  @observable id

  @computed get tags() {
    let tags = [ ...this.tagById.entries() ].map( item => item[ 1 ] )
    // console.log("TAGS", tags)
    return tags
  }

  constructor( data ) {
    Object.assign( this, data )
  }

  @action
  post = () => {
    this.loading = true

    console.log( "UPDATE" )
    const { id } = this
    const products = this.tags.filter( p => !p.deleted )
    const url = `${BASE}/wp/wp-json/shoppable/v1/img/${id}`

    // console.log("POST", {id, products})
    return fetch( url, {
      headers: {
        'Accept':       'application/json',
        'Content-Type': 'application/json'
      },
      method:  "POST",
      body:    JSON.stringify( { products } )
    } )
      .then( res => res.json() )
      .then( res => {
        this.loading = false
        // console.log({res})
      } ).catch( err => {
        this.loading = false
      } )
  }


  @action
  addTag( tag ) {
    this.tagById.set( tag.id, tag )
  }

  @action
  removeTag( tag ) {
    this.tagById.delete( tag.id )
  }
}

export class ImageStore {
  @observable  epics = new Map()
  @observable images = []
  @observable bySlug = new Map()
  @observable categories = []
  @observable categoryBySlug = new Map()
  @observable byCategory = new Map()

  addImage( id, img ) {
    this.epics.set( `${id}`, img )
    this.images = [ ...this.epics.entries() ].map( e => e[ 1 ] )
  }


  @action
  getBySlug = ( slug ) => {
    return fetch( `${BASE}/wp/wp-json/shoppable/v1/slug/${slug}` )
      .then( res => res.json() )
      .then( res => {
        res.products = res.products || []
        console.log( "IMAGE LOADED", res )
        const image = new EImage( res )
        image.src = res.img
        shop.products.list( res.products.map( p => p.productId ) )
        res.products.forEach( ( p, index ) => {
          const tag = new Tag( p )
          image.tagById.set( tag.id, tag )
        } )

        this.addImage( image.id, image )
        this.bySlug.set( image.slug, image )
      } )
      .catch( ( e ) => {

      } )
  }

  @action
  get = ( id ) => {
    const image = this.epics.get( id ) || new EImage( { id } )
    return fetch( `${BASE}/wp/wp-json/shoppable/v1/img/${id}` )
      .then( res => res.json() )
      .then( res => {
        res.products = res.products || []
        // console.log("IMAGE LOADED", res)
        image.src = res.img
        image.img = res.img
        image.title = res.title
        image.category = res.category
        shop.products.list( res.products.map( p => p.productId ) )
        res.products.forEach( ( p, index ) => {
          const tag = new Tag( p )
          // console.log("PRODUCT", tag)
          image.tagById.set( tag.id, tag )
        } )

        this.addImage( id, image )
      } )
      .catch( ( e ) => {

      } )
  }

  // TODO GET INDEX
  getIndex = () => {
    const url = `${BASE}/wp/wp-json/shoppable/v1/index?per_page=250`
    return fetch( url, {
      headers: {
        'Accept':       'application/json',
        'Content-Type': 'application/json'
      },
      method:  "GET"
    } )
      .then( res => res.json() )
      .then( res => {
        this.byCategory = new Map()
        const { images, categories } = res
        this.categories = categories
        this.categories.forEach( category => {
          this.categoryBySlug.set( category.slug, category )
        } )

        this.loading = false
        images.forEach( image => {
          const eImage = new EImage( image )
          this.addImage( image.id, eImage )
          this.bySlug.set( image.slug, eImage )
          const categoryBucket = this.byCategory.get( image.category ) || []
          categoryBucket.push( eImage )
          this.byCategory.set( image.category, categoryBucket )
        } )
      } ).catch( err => {
        this.loading = false
      } )
  }
}

const imageStore = new ImageStore()
window.imageStore = imageStore
export default imageStore

@observer
export class ImageContainer extends React.Component {

  state = {
    eImage:     false,
    usePreview: false
  }

  componentDidMount() {
    const id = this.props.id
    imageStore.addImage( id, new EImage( { id } ) )
    const eImage = imageStore.epics.get( id )
    this.setState( { eImage } )
  }

  togglePreview = () => {
    this.setState( { usePreview: !this.state.usePreview } )
  }

  render() {
    const { isEditor, useEditor } = cmsStore
    const { eImage, usePreview } = this.state
    if ( !eImage ) return null

    return <div>
      <h2 className="fw2">Ideen für Umtöpfe</h2>
      {!useEditor && <Epic image={eImage}/>}
      {useEditor && <EpicEditor image={eImage}/>}
    </div>
  }
}

@observer
export class TagForm extends React.Component {
  state = {}

  handleChange = ( e, { value } ) => {
    const { image } = this.props
    this.setState( { value } )
    image.post()
  }

  componentDidMount() {
    let { tag } = this.props
    if ( tag ) {
      if ( tag.productId ) productStore.get( tag.productId )
      // console.log("LOADING PRODUCT", tag.productId)
    }
  }

  handleProduct = ( { product } ) => {
    let { tag, image } = this.props
    // console.log({product})
    tag.productId = product.map_id
    productStore.get( tag.productId )

    this.forceUpdate()
  }

  handleDelete = ( product ) => {
    const { image } = this.props
    image.removeTag( product )
    image.post()
  }

  render() {
    const { tag } = this.props
    const product = productStore.productById.get( tag.productId )
    return (
      <Form>
        <Grid columns={2}>
          <Grid.Row>
            <Grid.Column>
              <Header inverted>Wähle ein Produkt</Header>
              <Typeahead
                defaultValue={tag.productId}
                onSelect={this.handleProduct}
                fluid label="Article Id"/>
              {/*<pre>{JSON.stringify(tag, null, 2)}</pre>*/}

              {/*<Form.TextArea label="About" placeholder="Tell us more about you..." />*/}

            </Grid.Column>
            <Grid.Column>
              <Header inverted>Vorschau</Header>
              <Card.Group itemsPerRow={1} className="justify-end">
                {product && <ProductCard product={product}/>}
              </Card.Group>
              {!product && <div>PRODUKT WÄHLEN</div>}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <div className="pt3 ph2 overflow-hidden tr">
              <Button
                as={Link}
                to={{ search: "" }}
                state={{ preventScrollToTop: true }}
                basic icon={"trash"} onClick={() => {
                this.handleDelete( tag )
              }} color={"red"}/>
              <Button
                as={Link}
                to={{ search: "" }}
                state={{ preventScrollToTop: true }}
                primary
                onClick={this.handleChange}
              >OK</Button>
            </div>
          </Grid.Row>
        </Grid>

      </Form>
    )
  }
}

@withRouter
@observer
export class EpicEditor extends React.Component {

  state = {
    aspect: 16 / 9
  }

  handleLoad = ( e ) => {
    let $img = e.target
    const { width, height } = $img
    const aspect = width / height
    // console.log("WIDTH", {width, height})
    this.setState( { aspect, width, height } )
  }

  handleClick = ( e ) => {
    const { image } = this.props
    if ( this.__dismissNextClickEvent ) {
      this.__dismissNextClickEvent = false
      return
    }

    let tag = new Tag( `${Math.random().toString( 32 )}` )
    this.placeTagByEvent( e, tag )
    image.addTag( tag )
  }

  getDomNode() {
    const $el = document.querySelector( "#ShoppableImage-Container" )
    if ( !$el ) throw(new Error( "Couldn't find #ShoppableImage-Container" ))
    return $el
  }

  placeTagByEvent( e, tag ) {

    const $el = this.getDomNode()
    const w = $el.offsetWidth
    const h = $el.offsetHeight

    let x = e.nativeEvent.offsetX - 20
    let y = e.nativeEvent.offsetY - 21

    this.placeTag( tag, x, y, w, h )
  }

  placeTag( tag, xPixel, yPixel, w, h ) {
    const x = `${xPixel / w * 100}`
    const y = `${yPixel / h * 100}`
    tag.place( { x, y } )
  }

  onDragStart = ( e, tag ) => {
    // console.log("onDragStart", tag)
    this.lastDraggedItem = tag
  }

  onDragOver = ( e ) => {
    // console.log("onDragOver")
    e.preventDefault()
  }

  onDrop = ( e ) => {
    const { image } = this.props
    let tag = this.lastDraggedItem
    // console.log("onDrop", tag)
    this.placeTagByEvent( e, tag )
    image.post()
  }

  handleError = ( e ) => {
    // console.log("EPIC: ERROR", e)
  }

  render() {

    const { image } = this.props
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    const editTag = query.tag
    const { src, tagById } = image
    const { aspect } = this.state
    const tags = [ ...tagById.entries() ].map( e => e[ 1 ] )
    const tag = tagById.get( editTag )

    return (
      <div className="ShoppableImage EpicEditor">
        <div
          className="img-container relative cover droppable"
          onDragOver={this.onDragOver}
          onDrop={this.onDrop}
          id={"ShoppableImage-Container"}
          onClick={this.handleClick}
          style={{
            height:          0,
            paddingBottom:   `${1 / aspect * 100}%`,
            width:           "100%",
            backgroundImage: `url(${src})`
          }}>
          {tags.map( tag => {
              const { top, left, id } = tag
              return <Button
                className="absolute draggable"
                as={Link}
                to={{ search: `?tag=${id}` }}
                onClick={() => {
                  this.__dismissNextClickEvent = true
                }}
                draggable
                onDragStart={e => this.onDragStart( e, tag )}
                title={id}
                key={id}
                icon="tag"
                circular
                style={{ top, left }}/>
            }
          )}
        </div>

        <div className="editor">
          <Menu>
            <Menu.Item><Segment inverted compact loading={image.loading} color={"green"}><Icon name="check"/> Gespeichert</Segment></Menu.Item>
            <Menu.Item position={"right"}><Button as={Link} target={"_blank"} to={`${shop.config.BASE}/wp/wp-admin/post.php?post=${image.id}&action=edit`} primary>BILD
              ÄNDERN</Button></Menu.Item>
          </Menu>
        </div>

        {tag && <Modal open basic>
          <Modal.Content>
            <TagForm tag={tag}
                     tagId={tag.id}
                     image={image}/>
          </Modal.Content>
        </Modal>}

        {/*HANDLE LOAD EVENTS */}
        <div className="dn">
          <Image
            onLoad={this.handleLoad}
            onError={this.handleError}
            src={image.img}/>
        </div>

        <div className="pv3">
          <ProductList
            title={"Artikel im Bild"}
            list={tags.map( tag => tag.productId )}
            repeat={ProductCard}/>
        </div>

        {/*<div className="pb3 pt4">*/}
        {/*<h2 className="fw2"> Ähnliche Artikel </h2>*/}
        {/*<Card.Group itemsPerRow={4}>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*</Card.Group>*/}
        {/*</div>*/}
      </div>
    )
  }
}

export class ProductLoader extends React.Component {

  state = {
    product: null,
    error:   null
  }

  componentDidMount() {
    const { id } = this.props
    shop.product( id )
      .then( product => {
        this.setState( { product } )
      } ).catch( err => {
      this.setState( { error: "Nicht verfügbar" } )
    } )
  }

  render() {
    const { product } = this.state
    const RenderComponent = this.props.as
    if ( !product ) return <div>LOADING</div>
    return <div><RenderComponent product={product}/></div>
  }
}

export class HoverButton extends React.Component {

  render() {
    const { tag, to, title, style, active } = this.props


    return (
      <React.Fragment>
        {active && <div className="ProductPreview animated fadeIn">
          <ProductLoader id={tag.productId} as={ProductCard}/>
        </div>}
        <Button
          active={active}
          className={"HoverButton"}
          as={Link}
          to={to}
          title={title}
          icon="tag"
          circular
          style={style}/>
      </React.Fragment>
    )
  }
}

@withRouter
@observer
export class Epic extends React.Component {

  state = {
    aspect: 16 / 9,
    node:   false
  }

  handleLoad = ( e ) => {
    let $img = e.target
    const { width, height } = $img
    const aspect = width / height
    this.setState( { aspect, width, height } )
  }

  onDragStart = ( e, tag ) => {
    // console.log("onDragStart", tag)
    this.lastDraggedItem = tag
  }

  onDragOver = ( e ) => {
    // console.log("onDragOver")
    e.preventDefault()
  }

  onDrop = ( e ) => {
    let tag = this.lastDraggedItem
    // console.log("onDrop", tag)
  }

  handleError = ( e ) => {
    // console.log("EPIC: ERROR", e)
  }


  render() {

    const { location, image, } = this.props
    const query = queryString.parse( this.props.location.search.substr( 1 ) )
    const editTag = query.tag
    const { src, tagById } = image
    const { aspect, node } = this.state
    const tags = [ ...tagById.entries() ].map( e => e[ 1 ] )
    const tag = tagById.get( editTag )

    // console.log({tags})

    return (
      <div className="ShoppableImage ">
        <div
          className="img-container relative cover droppable"
          onDragOver={this.onDragOver}
          onDrop={this.onDrop}
          id={"ShoppableImage-Container"}
          onClick={this.handleClick}
          style={{
            height:          0,
            paddingBottom:   `${1 / aspect * 100}%`,
            width:           "100%",
            backgroundImage: `url(${src})`
          }}>
          {tags.map( tag => {
              const { top, left, id } = tag
              return <HoverButton
                active={editTag === tag.id}
                context={node}
                tag={tag}
                to={{ search: `?tag=${id}` }}
                title={tag.productId}
                key={id}
                icon="tag"
                circular
                style={{ top, left }}/>
            }
          )}
        </div>

        {/*<div className="editor">*/}
        {/*<Menu attached={"top"}>*/}
        {/*/!*<Menu.Item><Button primary>PRODUKT HINZUFÜGEN</Button></Menu.Item>*!/*/}
        {/*<Menu.Item position={"right"}><Button primary icon={"shopping cart"}/></Menu.Item>*/}
        {/*</Menu>*/}
        {/*</div>*/}

        {/*{tag && <Modal*/}
        {/*basic*/}
        {/*open*/}
        {/*size="fullscreen"*/}
        {/*closeOnDocumentClick*/}
        {/*onClose={() => {*/}
        {/*this.props.history.replace( this.props.location.pathname )*/}
        {/*}}*/}
        {/*>*/}
        {/*<div className="fixed top-2 left-2">*/}
        {/*<Button circular basic inverted as={Link} to={this.props.location.pathname} icon="close"/>*/}
        {/*</div>*/}
        {/*<Modal.Content>*/}
        {/*<ProductList*/}
        {/*center*/}
        {/*list={[ tag.productId ]}*/}
        {/*repeat={ProductCard}/>*/}
        {/*<div className="pt2 tc ">*/}
        {/*/!*<Button.Group>*!/*/}
        {/*/!*<Button as={Link} to={this.props.location.pathname} icon="close"/>*!/*/}
        {/*/!*<Button icon={"chevron left"}/>*!/*/}
        {/*/!*<Button icon={"chevron right"}/>*!/*/}
        {/*/!*</Button.Group>*!/*/}
        {/*</div>*/}
        {/*</Modal.Content>*/}
        {/*</Modal>}*/}

        {/*HANDLE LOAD EVENTS */}
        <div className="dn">
          <Image
            onLoad={this.handleLoad}
            onError={this.handleError}
            src={image.img}/>
        </div>


        <div className="pv3">
          <ProductList
            title={"Artikel im Bild"}
            list={tags.map( tag => tag.productId )}
            repeat={ProductCard}/>
        </div>

        {/*<div className="pb3 pt4">*/}
        {/*<h2 className="fw2"> Ähnliche Artikel </h2>*/}
        {/*<Card.Group itemsPerRow={4}>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*<Card>*/}
        {/*<Card.Content> P0</Card.Content>*/}
        {/*</Card>*/}
        {/*</Card.Group>*/}
        {/*</div>*/}

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/ShoppableImage/imageStore.js